import { useEffect, useState } from "react";
import { FrequencyCellRenderer } from "./AllCellRenderers";
import cronstrue from "cronstrue";
import { ITooltipParams } from "ag-grid-community";
import * as Sentry from "@sentry/react";

type TString = string | React.ReactNode;
type TCron = React.MouseEvent<HTMLDivElement, MouseEvent>;

const ParseCronString = (params: ITooltipParams) => {
    const [datasetVal, setDatasetVal] = useState<string>("desc");
    const [currentString, setCurrentString] = useState<TString>();
    const [prevString, setPrevString] = useState<TString>();
    const { value } = params;
    useEffect(() => {
        try {
            setCurrentString(value ? (cronstrue || "").toString(value) : "");
        } catch (err) {
            console.error(err);
            Sentry.captureException(err);
        }
    }, [value]);

    const cronHandler = (e: TCron) => {
        if (!(e.target instanceof HTMLElement)) {
            return;
        }

        if (e.target.dataset.view === "desc") {
            setPrevString(currentString);
            setCurrentString(<code>{value}</code>);
            setDatasetVal("cron");
        } else {
            setCurrentString(prevString);
            setDatasetVal("desc");
        }
    };

    if (params.data.frequency_value) {
        return FrequencyCellRenderer(params);
    } else {
        return (
            <>
                {params.node.rowPinned ? null : (
                    <div
                        className="cron-cell-view text-success w-100 h-100"
                        style={{ cursor: "pointer" }}
                        onClick={(e: TCron) => cronHandler(e)}
                        data-view={datasetVal}
                    >
                        {currentString}
                    </div>
                )}
            </>
        );
    }
};

export default ParseCronString;
